<template>
  <div class="mine-content">
    <div class="m-content">
      <MineType v-for = "(pep,index) in testPassages" :content="pep" :key="index" v-on:listenToChildEvent="showMsg"></MineType>
      <div class="btn-group">
        <button class="default-btn large-btn" v-if="next" @click="toNext">下一题</button>
        <button class="default-btn large-btn" :class="show?'half-opacity':''" v-if="nextPage" @click="toNext">下一页</button>
        <button class="default-btn large-btn submit-btn" v-if="submit" @click="submitDta" v-preventReClick>提交</button>
      </div>
    </div>
  </div>
</template>

<script>
import MineType from '../components/MineType';
import axios from 'axios';
import qs from 'qs';
import store from '../store/index'
import setWechatTitle from '@/utils/setWechatTitle.js'
import { mapState } from 'vuex'

export default {
  props: {
    id: Number
  },
  name: 'mineSweeping',
  components:{
    'MineType':MineType
  },
  data(){
    return {
      testPassages:[
        {'num':1,'order':'1.','title':'先做个热身：想到自己所学的专业，你的感受是：','type':1,'show':true,'subTitle':['喜欢的','热情投入的','迷茫的','有信心的'],'answer':[1,2,3,4],titleArr: ['非常不符合', '2', '3', '4', '5', '6', '7', '8', '非常符合'],errorMessage:''},
        {'num':2,'order':'2.','title':'大学毕业后，你的打算是？','type':2,'show':true,'options':['A.	国内升学','B.	出国留学','C.	就业','D.	创业'],errorMessage:''},
        {'num':3,'order':'3.','title':'你对以上打算的确定程度是？','type':3,'show':true,fixArr: ['非常不确定', '', '', '', '', '', '', '', '非常确定'],errorMessage:''},
        {'num':4,'order':'4.','title':'对于大学期间要如何度过，你做过规划吗？','type':2,'show':true,'options':['A.做了清晰的规划，并在稳步执行中','B.做了清晰的规划，但总是不能坚持执行','C.只有大概的计划','D.从未做过'],errorMessage:''},
        {'num':5,'order':'5.','title':'在大多数情况下，你习惯使用的决策方式是？','type':2,'show':true,'options':['A.理智型：依赖逻辑分析，搜集大量信息，对可能的多种选择进行仔细的权衡比较后，做出“应该这么做”的最优决定','B.直觉型：依赖直觉，通常做出感觉适合我的决策，感觉对了就好。','C.依赖型：通常在他人的帮助、支持或建议下，才能做出重要的决策。','D.回避型：常常推迟或回避做出重要决策，直到最后不得不做出决定。'],errorMessage:''},
        {'num':6,'order':'6.','title':'我知道自己不得不做出职业选择，但是由于各种原因我现在不想做决定。','type':3,'show':false,fixArr: ['非常不符合', '', '', '', '', '', '', '', '非常符合'],errorMessage:''},
        {'num':7,'order':'7.','title':'我认为自己现在不需要进行生涯选择，这是一个水到渠成的过程，时间到了自然就会有正确的答案了。','type':3,'show':false,fixArr: ['非常不符合', '', '', '', '', '', '', '', '非常符合'],errorMessage:''},
        {'num':8,'order':'8.','title':'我需要得到专业人士或我所信任的人对我所做决定的不断肯定和支持，才能做决定。','type':3,'show':false,fixArr: ['非常不符合', '', '', '', '', '', '', '', '非常符合'],errorMessage:''},
        {'num':9,'order':'9.','title':'我经常拖延做出决定的时间。','type':3,'show':false,fixArr: ['非常不符合', '', '', '', '', '', '', '', '非常符合'],errorMessage:''},
        {'num':10,'order':'10.','title':'我很害怕失败。','type':3,'show':false,fixArr: ['非常不符合', '', '', '', '', '', '', '', '非常符合'],errorMessage:''},
        {'num':11,'order':'11.','title':'我常常觉得自己很难做出重要决定。','type':3,'show':false,fixArr: ['非常不符合', '', '', '', '', '', '', '', '非常符合'],errorMessage:''},
        {'num':12,'order':'12.','title':'我选择的职业要能够满足我所有的期待标准。','type':3,'show':false,fixArr: ['非常不符合', '', '', '', '', '', '', '', '非常符合'],errorMessage:''},
        {'num':13,'order':'13.','title':'我选择的职业必须与自己所学专业对口。','type':3,'show':false,fixArr: ['非常不符合', '', '', '', '', '', '', '', '非常符合'],errorMessage:''},
        {'num':14,'order':'14.','title':'只要我努力，我可以做任何的工作。','type':3,'show':false,fixArr: ['非常不符合', '', '', '', '', '', '', '', '非常符合'],errorMessage:''},
        {'num':15,'order':'15.','title':'我不知道做出职业选择应该采取什么步骤。','type':3,'show':false,fixArr: ['非常不符合', '', '', '', '', '', '', '', '非常符合'],errorMessage:''},
        {'num':16,'order':'16.','title':'我不知道做出职业选择需要考虑哪些因素。','type':3,'show':false,fixArr: ['非常不符合', '', '', '', '', '', '', '', '非常符合'],errorMessage:''},
        {'num':17,'order':'17.','title':'我不知道如何结合自身特点和职业特点来做出职业选择。','type':3,'show':false,fixArr: ['非常不符合', '', '', '', '', '', '', '', '非常符合'],errorMessage:''},
        {'num':18,'order':'18.','title':'我不知道自己最想做什么样的工作。','type':3,'show':false,fixArr: ['非常不符合', '', '', '', '', '', '', '', '非常符合'],errorMessage:''},
        {'num':19,'order':'19.','title':'我不知道以自己的性格和能力，适合做什么样的工作。','type':3,'show':false,fixArr: ['非常不符合', '', '', '', '', '', '', '', '非常符合'],errorMessage:''},
        {'num':20,'order':'20.','title':'我不知道我的能力/性格未来会发生什么样的变化因而难以做出职业决策。','type':3,'show':false,fixArr: ['非常不符合', '', '', '', '', '', '', '', '非常符合'],errorMessage:''},
        {'num':21,'order':'21.','title':'我对社会上的职业都不怎么了解，不知道我可以考虑的职业选项都有哪些。','type':3,'show':false,fixArr: ['非常不符合', '', '', '', '', '', '', '', '非常符合'],errorMessage:''},
        {'num':22,'order':'22.','title':'对于我感兴趣的职业，我了解的还很不够。','type':3,'show':false,fixArr: ['非常不符合', '', '', '', '', '', '', '', '非常符合'],errorMessage:''},
        {'num':23,'order':'23.','title':'我不清楚未来的职业世界会发生什么样的变化。','type':3,'show':false,fixArr: ['非常不符合', '', '', '', '', '', '', '', '非常符合'],errorMessage:''},
        {'num':24,'order':'24.','title':'我不知道通过哪些方法/途径来更多的了解我自己。','type':3,'show':false,fixArr: ['非常不符合', '', '', '', '', '', '', '', '非常符合'],errorMessage:''},
        {'num':25,'order':'25.','title':'我不知道如何获得关于职业的准确的、最新的信息。','type':3,'show':false,fixArr: ['非常不符合', '', '', '', '', '', '', '', '非常符合'],errorMessage:''},
        {'num':26,'order':'26.','title':'我总是担心自己了解的信息不全面或不准确而不敢做决定。','type':3,'show':false,fixArr: ['非常不符合', '', '', '', '', '', '', '', '非常符合'],errorMessage:''},
        {'num':27,'order':'27.','title':'我担心因所选职业不能达到我的期望而后悔。','type':3,'show':false,fixArr: ['非常不符合', '', '', '', '', '', '', '', '非常符合'],errorMessage:''},
        {'num':28,'order':'28.','title':'我同时被几个职业所吸引，而我不知道如何取舍。','type':3,'show':false,fixArr: ['非常不符合', '', '', '', '', '', '', '', '非常符合'],errorMessage:''},
        {'num':29,'order':'29.','title':'在我可选的范围内，没有一个职业是我喜欢的。','type':3,'show':false,fixArr: ['非常不符合', '', '', '', '', '', '', '', '非常符合'],errorMessage:''},
        {'num':30,'order':'30.','title':'适合我的工作和我所喜欢的不一致。','type':3,'show':false,fixArr: ['非常不符合', '', '', '', '', '', '', '', '非常符合'],errorMessage:''},
        {'num':31,'order':'31.','title':'我最想从事的职业发展前景并不好 。','type':3,'show':false,fixArr: ['非常不符合', '', '', '', '', '', '', '', '非常符合'],errorMessage:''},
        {'num':32,'order':'32.','title':'我发现生涯决策很难，因为我想做的工作总是在变化（有时想做教师，有时想做销售）。','type':3,'show':false,fixArr: ['非常不符合', '', '', '', '', '', '', '', '非常符合'],errorMessage:''},
        {'num':33,'order':'33.','title':'我发现生涯决策很难，因为没有一个职业选择能让我完全满意（如，我喜欢当自由职业者，但是我又想要稳定的薪酬）。','type':3,'show':false,fixArr: ['非常不符合', '', '', '', '', '', '', '', '非常符合'],errorMessage:''},
        {'num':34,'order':'34.','title':'我发现生涯决策很难，因为通过不同的途径和方法搜集到的职业信息存在矛盾的地方。','type':3,'show':false,fixArr: ['非常不符合', '', '', '', '', '', '', '', '非常符合'],errorMessage:''},
        {'num':35,'order':'35.','title':'我发现生涯决策很难，因为我对自己的看法和别人对我的看法存在冲突。','type':3,'show':false,fixArr: ['非常不符合', '', '', '', '', '', '', '', '非常符合'],errorMessage:''},
        {'num':36,'order':'36.','title':'我发现生涯决策很难，因为生活中我认为重要的人不同意我现在正在考虑/感兴趣的选择。','type':3,'show':false,fixArr: ['非常不符合', '', '', '', '', '', '', '', '非常符合'],errorMessage:''},
        {'num':37,'order':'37.','title':'我发现生涯决策很难，因为生活中我认为重要的人的意见相互冲突。','type':3,'show':false,fixArr: ['非常不符合', '', '', '', '', '', '', '', '非常符合'],errorMessage:''},
        {'num':38,'order':'38.','title':'入校以来你使用过哪些生涯教育/就业指导资源？（多选）','type':4,'show':false,'options':['A.生涯规划课程','B.就业指导课程','C.讲座','D.针对性的培训/训练营','E.职业测评','F.学业指导','G.1对1咨询','H.团体辅导','I.实习/实践','J.就业政策咨询','K.就业信息服务（信息网、微信公众号等）','L.都没用过','M.其他'],errorMessage:''},
        {'num':39,'order':'39.','title':'以上你使用过的资源中，你觉得对自己是否有帮助？ ','type':1,'show':false,'subTitle':['A.生涯规划课程','B.就业指导课程','C.讲座','D.针对性的培训/训练营','E.职业测评','F.学业指导','G.1对1咨询','H.团体辅导','I.实习/实践','J.就业政策咨询','K.就业信息服务（信息网、微信公众号等）','L.都没用过','M.其他'],answer:[],titleArr: ['一点儿帮助都没有', '2', '3', '4', '5', '6', '7', '8', '非常有帮助'],errorMessage:''},
        {'num':40,'order':'40.','title':'总体来讲，你对学校生涯教育/就业指导资源的感受是？ ','type':5,'show':false,'subTitle':['我清楚的知道都有哪些生涯教育/就业指导资源','如果需要，我能方便快速的获得相关资源的信息（主题、细节等）','资源的形式和内容多样','能满足我在生涯规划/就业指导方面的需求'],answer:[1,2,3,4],errorMessage:''},
        {'num':41,'order':'41.','title':'除了以上，你对学校的生涯教育/就业指导资源还想说？。','type':6,'show':false,errorMessage:''}
      ],
      next:false,
      nextPage:true,
      submit:false,
      current:1,
      currentAnswer:'',
      answers:[],
      options:[],
      result:'',
      arrayAnswer:[],
      show:true,
      submitNum:0
    }
  },
  computed: {
    ...mapState({
      shengyaUser: state => state.shengyaUser.userInfo,
    }),
  },
  created(){
    setWechatTitle('生涯驿站-生涯扫雷');
  },
  methods:{
    showMsg(res,cur,type,s){
      let count =0;
      if(this.testPassages[cur-1].answer){
        count=this.testPassages[cur-1].answer.length
      }
      this.current = cur;
      if(type==1||type==5){
        // 题型为1、5的答案
        this.currentAnswer = ''
        if(this.answers.length>count){
          this.answers=[]
        }
        let chooseData ={id:s,res:res}
        this.answers.map((item,index)=>{
          if(item.id==s){
             this.answers.splice(index,1)
          }
        })
        this.answers.push(chooseData)
        if(this.answers.length==count){
          this.answers.sort((a,b)=>{return a.id-b.id});
          this.answers.map((item,zindex)=>{
            this.currentAnswer += (zindex+1)+'<'+item.res
            if(zindex+1<count){
              this.currentAnswer +=','
            }
          })
          this.testPassages[this.current-1].errorMessage=''
          this.answers=[]
        }
       }else{
         // 题型为4的答案
          if(type==4){
            this.currentAnswer =''
            let no = this.options.indexOf(res)
            if(no>=0){
                this.options.splice(no,1)
            }else{
               this.options.push(res);
            }
            this.testPassages[cur].answer = this.options
            if(this.options.length>=2){
              this.options.sort((a,b)=>{return a-b});
              this.currentAnswer = this.options.join('|')
              this.testPassages[this.current-1].errorMessage=''
              this.arrayAnswer.map((item,index)=>{
                if(cur==38&&item.id==cur+1){
                  this.arrayAnswer.splice(index,1)
                }
              })
            }
          }else{
            // 题型为2、3、6的答案
            this.currentAnswer = res;
            this.testPassages[this.current-1].errorMessage=''
          }
       }
       if(this.currentAnswer){
         this.arrayAnswer.map((item,index)=>{
           if(item.id==cur){
              this.arrayAnswer.splice(index,1)
           }
         })
         this.arrayAnswer.push({id:cur,res:this.currentAnswer})
         this.arrayAnswer.sort((a,b)=>{return a.id-b.id});
         let m =  this.arrayAnswer[0].id
         if(m==1&&this.arrayAnswer.length==5){
          this.show = false
         }else if(m==6&&this.arrayAnswer.length==32){
           this.show = false
         }
       }
       else{
         this.arrayAnswer.map((item,index)=>{
          if(item.id==cur){
            this.arrayAnswer.splice(index,1)
          }
         })
       }
      },
      // 下一题或下一页事件
      toNext(){
          const now=this.current+1
          if(this.checkAnswer()){
            this.testPassages.map((item,index)=>{
              if(item.show){
                item.show=false;
                if(this.answers){
                  this.answers=[]
                }
              }
              if(5<=index&&index<=36&&now<=6){
                item.show=true;
                this.nextPage=true
                this.show = true
                this.submit=false
              }else if(37<=index&&index<=40&&now>=7){
                 item.show=true
                this.nextPage=false
                this.submit=true
              }
            })
            this.addAnswerToResult()
          }
        },
        // 检查题目是否为空
        checkAnswer(){
          const now=this.current+1
          let next=true
          // 当前题答案为空时,提示错误
          if(this.arrayAnswer.length<5&&now<=6){
            next=false;
          }else if(7<=now&&now<=38&&this.arrayAnswer.length<32){
            next=false;
          }else if(39<=now&&now<=42){
            if(this.arrayAnswer.length<3){
              next=false
            }else{
              let array = [38,39,40]
              this.arrayAnswer.map((answer,index)=>{
                let n = array.indexOf(answer.id)
                if(n>=0){
                  array.splice(n,1)
                }
              })
              if(array.length>0){
                next=false
              }
            }
          }
          if(!next){
            this.testPassages.map((item,index)=>{
              if(item.show&&item.num<41){
                item.errorMessage='请回答此题'
              }
              this.arrayAnswer.map((answer,n)=>{
                if(item.num==answer.id){
                  item.errorMessage=''
                }
              })
            })
            next=false
          }
          return next
        },
        // 添加每一页的答案到总的答案中
        addAnswerToResult(){
          this.arrayAnswer.map((item,index)=>{
            let m = this.result.indexOf(item.id+"$")
            if(m>=0){
              this.result = this.result.substring(0,m);
            }
            this.result+=item.id+"$"+item.res;
            if(item.id<41){
              this.result+="}";
              this.currentAnswer='';
            }
          })
          let n =  this.arrayAnswer[0].id
          // 最后一页时不清空答案数组
          if(n<38){
            this.arrayAnswer=[]
          }
        },
        // 数据提交
        submitDta(){
          if(this.checkAnswer()&&this.submitNum==0){
            this.addAnswerToResult()
            this.submitNum=1
            const index = this.result.indexOf(41);
            // 答案中没有41题，添加41题的答案
            if(index==-1&&this.current==41){
              this.result+=this.current+"$"+this.currentAnswer;
            }
            const options = {
              method: 'POST',
              headers: {
                'content-type': 'application/x-www-form-urlencoded'
              },
              data: qs.stringify({
                submitdata: this.result,
                openId: this.shengyaUser.openid
              }),
              url: '/cob/saveCosCddqAnswer.do'
            };
            axios(options)
              .then((response)=>{
                if(response.data.result.success){
                  let cddqAnswer = response.data
                  let shengyaUser = cddqAnswer.data.user
                  this.$bus.$emit('play-finish', shengyaUser)
                }
              })
              .catch((error)=>{
                console.log(error)
              });
          }
        }
      }
    }
  </script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .mine-content{
    position: fixed;
    height:100%;
    display: -webkit-box; /* 老版本语法: Safari, iOS, Android browser, older WebKit browsers. */
    display: -moz-box; /* 老版本语法: Firefox (buggy) */
    display: -ms-flexbox; /* 混合版本语法: IE 10 */
    display: -webkit-flex; /* 新版本语法： Chrome 21+ */
    display: flex; /* 新版本语法： Opera 12.1, Firefox 22+ */
    /*垂直居中*/
    /*老版本语法*/
    -webkit-box-align: center; -moz-box-align: center; /*混合版本语法*/
    -ms-flex-align: center; /*新版本语法*/
    -webkit-align-items: center;
    align-items: center;
    /*水平居中*/ /*老版本语法*/
    -webkit-box-pack: center; -moz-box-pack: center; /*混合版本语法*/
    -ms-flex-pack: center; /*新版本语法*/
    -webkit-justify-content: center;
    justify-content: center;
    margin: 0;
    overflow-y: auto;
  }
  .m-content{
    min-width: 6.4rem;
    width: 100%;
  }
</style>
